import { Fragment, useEffect, useState } from 'react';

import { InvoiceService } from '../../hoa-don/InvoiceService';
import { RegisterInvoiceService } from '../../../service/invoice/RegisterInvoiceService';
import {
  AdjustmentReasonOption,
  OneBtsCatalogService,
} from '../../../service/invoice/OneBtsCatalogService';
import { CurrencyService } from '../../danh-muc/tien-te/CurrencyService';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';

import { DialogCrup } from '../../hoa-don/component/DialogCrup';
import { DialogView } from '../../hoa-don/component/DialogView';
import { DialogSelectInvoice } from '../../hoa-don/component/DialogSelectInvoice';

import { DialogStatement } from '../components/DialogStatement';
import { DialogAttachment } from '../components/DialogAttachment';
import { useSign } from '../../../shared/component/Sign';
import { StatementInvoiceService } from '../StatementInvoiceService';
import { DialogSendEmail } from '../../hoa-don/component/DialogSendEmail';
import { useTranslation } from '../../../shared/language';
import { getRegisteredAssetTypeCompany, isRegisteredAssetInvoice } from '../../../utils/invoiceHelper';

export const List = () => {

  const { t } = useTranslation();
  const header = t('menu.invoiceReplacement');
  const dataKey = 'invoiceId';

  const [displaySelectInvoice, setDisplaySelectInvoice] = useState(null);

  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const [displayCrup, setDisplayCrup] = useState(false);
  const [registerInvoice, setRegisterInvoice] = useState(null);
  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [currencies, setCurrencies] = useState(null);
  const [paymentTypes, setPaymentTypes] = useState(null);
  const [data, setData] = useState(null);
  const [displayStatement, setDisplayStatement] = useState(false);
  const [displayUpload, setDisplayUpload] = useState(false);
  const [displayView, setDisplayView] = useState(false);
  const [documentType, setDocumentType] = useState(InvoiceService.documentType_Substitute);
  const [displaySendEmail, setDisplaySendEmail] = useState(false);
  const [reasonOptions, setReasonOptions] = useState<AdjustmentReasonOption[]>([]);
  const print = (invoice) => {
    StatementInvoiceService.getByInvoice(invoice.invoiceId).then((res) => {
      window.open(StatementInvoiceService.getPdfUrl(res.id), '_blank');
    })
  }


  useEffect(() => {
    RegisterInvoiceService.getUsingList({ maxResultCount: 1000 }).then(({ items }) => {
      const _registerInvoices = [];
      items.forEach(item => {
        item.label = `${item.symbolCode} - ${item.invoiceTypeName}`;
        _registerInvoices.push(item);
      });
      setRegisterInvoices(_registerInvoices);
      setRegisterInvoice(_registerInvoices[0]);
      // Chỉ cần tải danh mục khi có mẫu BTS01 để tránh áp dụng lý do sai sót cho hóa đơn thông thường.
      if (_registerInvoices.some((item) => Number(item.typeCompany) === 9)) {
        OneBtsCatalogService.getAdjustmentReasonCatalog(
          InvoiceService.documentType_Substitute,
        )
          .then((response) =>
            setReasonOptions(
              Array.isArray(response)
                ? response
                : response?.options || response?.items || [],
            ),
          )
          .catch(() => setReasonOptions([]));
      }
    });
    CurrencyService.getList({}).then(({ items }) => {
      setCurrencies(items);
    });
    InvoiceService.getPaymentTypes().then(({ items }) => {
      const _paymentTypes = [];
      items.forEach(item => {
        _paymentTypes.push({ value: item.name, label: item.name });
      });
      setPaymentTypes(_paymentTypes);
    });
  }, []);

  const { render: renderDataTable, reloadLazyData, selectedItems } = useDataTable({
    header,
    dataKey,
    headerColumnGroups: [
      { header: t('menu.invoiceReplacement'), colSpan: 8 },
      { header: t('common.beingReplaced'), colSpan: 4 }
    ],
    columns: [
      { field: 'invoiceSerial', header: t('common.symbol'), width: 100, matchMode: 'contains', },
      {
        field: 'invoiceNumber', header: t('common.invoiceNo'), width: 110, matchMode: 'contains', dataType: 'custom', customCell(rowData): any {
          const text = rowData.invoiceNumber;
          return (
            <span className="underline text-primary" onClick={() => viewInvoice(rowData.invoiceId)}>{text}</span >
          );
        }, style: { justifyContent: 'center' }
      },
      { field: 'invoiceDate', header: t('common.invoiceDate'), width: 120, dataType: 'date' },
      {
        field: 'sendTaxStatus', header: t('common.submissionStatus'), width: 180, matchMode: 'contains', filterType: 'dropdown', filterOptions: InvoiceService.sendTaxStatuses, dataType: 'custom', customCell(rowData: any): any {
          if ([3, 4, 5].includes(rowData.sendTaxStatus)) {
            return <span className={`underline send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{InvoiceService.getSendTaxStatusLabel(rowData.sendTaxStatus)}</span>;
          }
            return <span className={`send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{InvoiceService.getSendTaxStatusLabel(rowData.sendTaxStatus)}</span>;
        }
      },
      {
        field: 'buyerLegalName', header: t('catalog.customer'), minWidth: 200, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return rowData.buyerLegalName || rowData.buyerDisplayName;
        }
      },
      {
        field: '', header: t('common.statement'), width: 110, sortable: false, dataType: 'custom', customCell(rowData): any {
          const text = rowData.hasDocument ? rowData.documentNo : t('common.statementCreate');
          const className = rowData.hasDocument ? "underline send-tax-status send-tax-status-4" : "underline text-primary";
          return (
            <span className={className} onClick={() => setDisplayStatement(true)}>{text}</span>
          );
        }, style: { justifyContent: 'center' }
      },
      {
        field: '', header: t('common.actions'), width: 100, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return (
            <div className='flex gap-3'>
              <i className="pi pi-link" title={t('common.attachment')} onClick={() => setDisplayUpload(true)}></i>
              {rowData.hasDocument && <i className="pi pi-print" title={t('common.printInvoice')} onClick={() => print(rowData)}></i>}
              <i className="pi pi-envelope" title={t('common.emailStatementForSignature')} onClick={() => {
                setDisplaySendEmail(true)
                StatementInvoiceService.getByInvoice(rowData.invoiceId).then((res) => {
                  setData(res)
                  // setSelectedItems(res);
                })
              }}></i>
            </div>
          );
        }, style: { justifyContent: 'center' }
      },
      { field: 'relatedInvoiceSerial', header: t('common.symbol'), width: 100, matchMode: 'contains' },
      {
        field: 'relatedInvoiceNumber', header: t('common.invoiceNo'), width: 110, matchMode: 'contains', dataType: 'custom', customCell(rowData): any {
          const text = rowData.relatedInvoiceNumber;
          return (
            <span className="underline text-primary" onClick={() => viewInvoice(rowData.relatedInvoiceId)}>{text}</span >
          );
        }, style: { justifyContent: 'center' }
      },
      { field: 'relatedInvoiceDate', header: t('common.invoiceDate'), width: 120, dataType: 'date' },
      {
        field: 'invoiceNote',
        header: t('common.invoiceReason'),
        width: 110,
        matchMode: 'contains',
        dataType: 'custom',
        customCell(rowData): any {
          if (!isRegisteredAssetInvoice(rowData, registerInvoices)) {
            return rowData.invoiceNote || '';
          }
          const reasonValue = rowData.reasons ?? rowData.invoiceNote ?? '';
          return reasonOptions.find(
            (option) => String(option.value) === String(reasonValue),
          )?.label || reasonValue;
        },
      }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      if (!params.sortType) {
        params.sortType = 'DESCEND';
      }
      if (!params.sorting) {
        params.sorting = 'invoiceDate';
      }

      params.IsOtherInvoice = false;
      return InvoiceService.getListSubstitutes(params);
    },
    selectionMode: 'single'
  });

  // API danh sách không trả typeCompany nên bổ sung từ mẫu đăng ký trước khi mở biên bản.
  const selectedItemsForStatement = Array.isArray(selectedItems)
    ? selectedItems.map((item) => ({
      ...item,
      typeCompany: getRegisteredAssetTypeCompany(item, registerInvoices),
    }))
    : selectedItems && {
      ...(selectedItems as Record<string, any>),
      typeCompany: getRegisteredAssetTypeCompany(selectedItems as any, registerInvoices),
    };

  const load = async () => {
    if (selectedItems && selectedItems.length > 0) {
      const selectedItem = selectedItems[0];
      const data = await StatementInvoiceService.getByInvoice(selectedItem.invoiceId || selectedItem.id);
      return data;
    }
    return null;
  }

  const viewInvoice = (id) => {
    setSelectedInvoice({
      id
    });
    setDisplayView(true);
  }

  const { renderToolbar } = useToolbar({
    dataKey,
    reloadLazyData,
    otherActions: [
      {
        label: t('common.registerReplacementInvoice'), icon: 'pi pi-fw pi-user-edit', className: 'iam-toolbar', command: () => {
          setDisplaySelectInvoice(true);
        }
      }
    ]
  });

  const onAddSelectedItems = (items) => {
    if (items) {
      setSelectedInvoice(items);
      setDisplayCrup(true);
    }
  }

  const { renderSign, sign } = useSign({ onComplete: reloadLazyData });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}

      {renderSign()}

      <DialogSelectInvoice display={displaySelectInvoice} setDisplay={setDisplaySelectInvoice} addSelectedItems={onAddSelectedItems} selectionMode="radiobutton"
        invoiceStatus="0,3" sendTaxStatus="2,4" />

      <DialogCrup display={displayCrup} setDisplay={setDisplayCrup} reloadLazyData={reloadLazyData}
        registerInvoices={registerInvoices} currencies={currencies} paymentTypes={paymentTypes}
        registerInvoice={registerInvoice} selectedItem={selectedInvoice} invoiceStatus={3}
        sign={sign} />

      <DialogAttachment display={displayUpload} setDisplay={setDisplayUpload} selectedItem={selectedItems} />

      <DialogStatement display={displayStatement} setDisplay={setDisplayStatement} selectedItem={selectedItemsForStatement} registerInvoices={registerInvoices} enableBts01ReasonCatalog documentType={documentType} reloadLazyData={reloadLazyData} title={t('common.replacement')} />

      <DialogView display={displayView} setDisplay={setDisplayView} selectedItem={selectedInvoice} />

      <DialogSendEmail display={displaySendEmail} setDisplay={setDisplaySendEmail} selectedItems={data} sendType={8} />
    </Fragment>
  )
}
